<template>
    <div class="container-base" v-once>
        <div class="bokumetsu-pages page-static">
            <div class="page-static-inner">
                <section class="hero">
                    <img src="/kr/resume/static/img/pages/bokumetsu/main.svg" alt="일본에서 튀어나온 수기 이력서들을 탄 흑염소와 빙글빙글 도는 지구"
                        class="mainimg">
                    <h1><img src="/kr/resume/static/img/pages/bokumetsu/h1.svg" alt="yagish(야기슈) 수기이력서 캠페인"></h1>
                </section>
                <section class="introduction">
                    <div class="sectiontop">
                        <h2>수기이력서 작성이 필요없는 시대</h2>
                        <p>이력서는 취업과 이직시에 제출을 요구하는 경우가 많은 서류입니다.<br>
                            구인구직시 웹 이력서 제출이 많은 요즘,[손글씨]가 그사람의 인품이나 열정을 보여줄수 없으며 PC로 작성한 이력서만 지원 할 수 있는 기업이 많아 졌습니다.</p>
                    </div>
                    <div class="container980">
                        <div class="merit">
                            <div class="circle">
                                <img src="/kr/resume/static/img/pages/bokumetsu/merit.svg" alt="손으로 쓸 필요가 없는 장점">
                            </div>
                            <div class="flex">
                                <div class="left">
                                    <h3>구직자메리트</h3>
                                    <img src="/kr/resume/static/img/pages/bokumetsu/jikanniyoyuu.svg"
                                        alt="시계를 든 야기의 이미지">
                                    <p>시간을확보</p>
                                    <img src="/kr/resume/static/img/pages/bokumetsu/syutyu.svg"
                                        alt="컴퓨터와 스마트폰을 앞에 두고 있는 야기의 이미지">
                                    <p>작성에 집중할 수 있다</p>
                                    <img src="/kr/resume/static/img/pages/bokumetsu/suguoubo.svg"
                                        alt="이력서를 많이 가지고 있으면서 직장을 생각하는 야기의 이미지">
                                    <p>지원하고싶다! 라고 생각하면 바로 지원 할수 있다.</p>
                                </div>
                                <div class="right">
                                    <h3>채용자메리트</h3>
                                    <img src="/kr/resume/static/img/pages/bokumetsu/yomiyasui.svg"
                                        alt="디지털 이력서의 읽기 쉬운 점을 어필하는 야기 이미지">
                                    <p>지원내용을 쉽게 읽을수있다</p>
                                    <img src="/kr/resume/static/img/pages/bokumetsu/kanisiyasui.svg"
                                        alt="A사와 B사를 비교해 보는 야기의 이미지">
                                    <p>데이터로 관리하기 쉽다</p>
                                    <img src="/kr/resume/static/img/pages/bokumetsu/ouboshitai.svg"
                                        alt="기뻐하는 기업과 야기의 이미지">
                                    <p>지원받기 쉽다</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="worry">
                    <div class="container980">
                        <div class="sectiontop">
                            <h2>그렇다고는 해도... 수기가 아니면 걱정되는 이유</h2>
                        </div>
                        <div class="flex">
                            <div class="worry-content">
                                <img src="/kr/resume/static/img/pages/bokumetsu/konki.svg"
                                    alt="붓으로 '끈기'라고 손으로 쓴 글자의 이미지">
                                <div class="worry-content-inner">
                                    <h3>수기작성이 좋은인상？</h3>
                                    <p>모집요강에는 없지만 손글씨의 장점으로 여겨지고 있는「열의와 성의가 전해진다」라는 점이 유리하게 작용할지도…라고 생각하게 됩니다.</p>
                                </div>
                            </div>
                            <div class="worry-content">
                                <img src="/kr/resume/static/img/pages/bokumetsu/hidennosyo.svg"
                                    alt="사무라이 야기가 '400년 전부터 전해 내려오는 비전 이력서 채용술'이라고 쓰인 두루마리를 들고 있는 이미지">
                                <div class="worry-content-inner">
                                    <h3>주위에서 손글씨를 권유받다</h3>
                                    <p>「이력서는 손글씨」라던 시대의 영향으로, 인사담당자가 손글씨를 좋아하겠다라는 생각으로 손글씨를 추천하고 있는 경우가 있습니다.</p>
                                </div>
                            </div>
                            <div class="worry-content">
                                <img src="/kr/resume/static/img/pages/bokumetsu/tegakirirekisyo.svg"
                                    alt="야기가 쓴 손으로 쓴 이력서의 이미지">
                                <div class="worry-content-inner">
                                    <h3>'애매할 땐 손글씨'가 낫다?</h3>
                                    <p>매뉴얼이나 WEB 사이트에서는 「애매할 땐 손글씨」라는 곳이 많아 지원자·채용자측 어느 쪽도 원하지 않지만 결과적으로 「애매할 땐 손글씨」한
                                        현상이 되어 버리고 있습니다.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="yagi-friends">
                    <!-- 君はもうヤギとおともだちだよ！🐐 -->
                    <div class="container980">
                        <div class="sectiontop">
                            <h2>야기로부터의 제안:손글씨 이력서는 불필요하다고 생각을 바꿔보세요.</h2>
                            <p class="thought-content">
                                <span>『수기불필요』</span>라고 외치면
                                수기를 망설이지 않아도 되고, 다들 행복해질 수 있을지도 몰라!
                            </p>
                        </div>
                        <div class="profile">
                            <div class="profile-inner">
                                <img src="/kr/resume/static/img/pages/bokumetsu/moguyagi.svg" alt="야기 프로필을 소개하는 야기 일러스트"
                                    class="moguyagi">
                                <h3><img src="/kr/resume/static/img/pages/bokumetsu/yaginopr.svg" alt="야기프로필"
                                        class="yagipr"></h3>
                                <a href="/kr/resume/gacha" target="_blank"><img
                                        src="/kr/resume/static/img/pages/bokumetsu/bokumetsuyagi-l.png"
                                        alt="ぴょんぴょん跳ねる元気な左向きの黒ヤギ" class="tobuyagi-l"></a>
                                <a href="/kr/resume/gacha" target="_blank"><img
                                        src="/kr/resume/static/img/pages/bokumetsu/bokumetsuyagi-r.png"
                                        alt="ぴょんぴょん跳ねる元気な右向きの黒ヤギ" class="tobuyagi-r"></a>
                                <p><span class="accent">「수기이력서가 아니어도 괜찮아！」</span>라고 생각하는 친구(기업)를 모아 취직 활동이나, 이직 활동을 열심히
                                    하는 사람들을 응원하기 위해서 날마다 분투중.</p>
                                <p>옛날에는 장난을 쳐서 주위 사람들을 힘들게 했지만, 지금은 남을 위해 개과천선함 .털 색깔이나 모습 때문에 무서워하는 경우가 많지만 심성은 착하다.한쪽
                                    뿔이 찢어져 있는 것은 오래된 상처.</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="juuoku">
                    <div class="container980">
                        <div class="container700">
                            <h2>모두같이 협력하면 100억원의 경제효과가<span>（있으지도）</span></h2>
                            <p>손으로 예쁘게 쓰려고 하면 빨라도 한 장 30분 정도 걸리는 이력서.내용을 고민하거나 틀리면 시간이 더 걸립니다.</p>
                            <p>한국에서는 매년 40만 명이 넘는 사람들이 대학을 졸업하고 신규 졸업자로 취직합니다.<br>
                                이 사람들이 한 사람당 다섯기업에 수기이력서를 썼을 때는 약 100만 시간의 시간이 사용되고 있다는 계산이 됩니다.시급 만원으로 환산하면<span
                                    class="accent">한 100억원！</span><br>
                                이직하는 사람이나 아르바이트도 합치면 그 몇 배나 되겠죠.이 시간을 학업이나 자기 분석, 기업 조사에 사용할 수 있다면 멋진 기업을 만날 가능성이 높아질 수도
                                있습니다.</p>
                            <div class="waste">
                                <div class="waste-inner">
                                    <div class="flex">
                                        <div class="time">
                                            <p>
                                                <span>0.5</span><br>시간
                                            </p>
                                        </div>
                                        <div class="kakeru">
                                            <p>×</p>
                                        </div>
                                        <div class="resume">
                                            <p>
                                                <span>5</span><br>명
                                            </p>
                                        </div>
                                        <div class="kakeru">
                                            <p>×</p>
                                        </div>
                                        <div class="population">
                                            <p><span>40</span><br>만명</p>
                                        </div>
                                        <div class="equal-vertical">
                                            <p>＝</p>
                                        </div>
                                    </div>
                                    <div class="total">
                                        <p>
                                            <span class="equal-transverse">＝</span><span class="million">100만</span>시간
                                        </p>
                                    </div>
                                </div>
                                <img src="/kr/resume/static/img/pages/bokumetsu/juuoku.svg" alt="백억원을 물고있는 야기"
                                    class="juuokuyagi">
                            </div>
                        </div>
                    </div>
                    <div class="containerfull campaign">
                        <div class="container980">
                            <div class="container700">
                                <div class="campaign-inner">
                                    <h3>
                                        <img src="/kr/resume/static/img/pages/bokumetsu/yagicampaign.svg"
                                            alt="캠페인 참여 방법">
                                    </h3>
                                    <p class="no1">캠페인에 동참해 주실 경우 기업·개인 불문하고<a
                                            href="https://twitter.com/search?q=%23手書き不要" target="_blank">#수기불필요</a>의
                                        해시태그를 달아 트윗 해주세요.</p>
                                    <p class="no2">기업의 경우는 해시태그나 간단한 코멘트와 함께 채용 페이지의 URL 등도 공유해 주시면 트윗을 본 지원자가 보다 쉽게 지원
                                        할 수 있어요.</p>
                                    <p class="no3">야기는 수기이력서가 불필요하다고 생각합니다만, 손글씨를 부정하는 캠페인은 아닙니다.공격적인 트윗이나 악의적인 말투는
                                        피해주셨으면 좋겠습니다.</p>
                                    <div class="bokumetsu-tweet">
                                        <p class="accent">『<span>#수기불필요</span>』의 해시태그로 트윗하자 ！</p>
                                        <a id="footer-social-share-twitter"
                                            href="http://twitter.com/intent/tweet?url=https://rirekisho.yagish.jp/bokumetsu/&amp;text=검정야기와 친구가 되었다! &amp;hashtags=수기불필요,yagish"
                                            rel="nofollow" target="_blank">트윗하기
                                        </a>
                                    </div>
                                </div>
                                <div class="tagyagi">
                                    <p>야기친구의 트윗을 봐주세요.</p>
                                    <a href="https://twitter.com/search?q=%23수기불필요" target="_blank">
                                        <img src="/kr/resume/static/img/pages/bokumetsu/hashtag.svg" alt="「#수기불필요해쉬태그">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div class="back-button">
                    <router-link to="/">야기슈사용해보기</router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" src="@/assets/scss/pages/bokumetsu.scss" scoped></style>
<script>
export default {
    data: function () {
        return {}
    },
    computed: {},
    methods: {},
    watch: {},
    mounted: function () { }
}
</script>
